const filterList = () => import('@/pages/product/filter/index.vue');

export default [{
    path: '/product/filter',
    component: filterList,
    meta: [{
        name: '产品管理',
		activeRoute: '/product/manage'
    },
    {
        name: '筛选器管理',
        activeRoute: '/product/filter'
    }]
}];